import React, { Dispatch, FC, SetStateAction } from 'react';
import { Modal } from '@wix/design-system';
import { DataHooks } from '../../../constants/dataHooks';
import { CLIModalLayout } from './CLIModal/CLIModalLayout';
import { SelfHostedModal } from './SelfHostedModal/SelfHostedModal';

export enum ActiveModal {
  CLI = 'CLI',
  SELF_HOSTED = 'SELF_HOSTED',
  NONE = '',
}

const ModalsConfiguration = {
  [ActiveModal.CLI]: {
    dataHook: DataHooks.CLIModal,
    ModalLayout: CLIModalLayout,
  },
  [ActiveModal.SELF_HOSTED]: {
    dataHook: DataHooks.SelfHostedModal,
    ModalLayout: SelfHostedModal,
  },
  [ActiveModal.NONE]: {
    dataHook: '',
    ModalLayout: () => <></>,
  },
};

type ModalRendererProps = {
  activeModal: ActiveModal;
  setActiveModal: Dispatch<SetStateAction<ActiveModal>>;
};
export const ModalRenderer: FC<ModalRendererProps> = ({
  activeModal,
  setActiveModal,
}) => {
  const { ModalLayout, dataHook } = ModalsConfiguration[activeModal];
  const closeModal = () => setActiveModal(ActiveModal.NONE);

  return (
    <Modal dataHook={dataHook} isOpen={activeModal !== ActiveModal.NONE}>
      <ModalLayout closeModal={closeModal} />
    </Modal>
  );
};
